import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PaystackPop from '@paystack/inline-js';
import api from '../../../lib/api';

export default function Resources() {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [payingId, setPayingId] = useState(null);

  useEffect(() => {
    fetchResources();
  }, []);

  const fetchResources = async () => {
    try {
      const res = await api.get('/resources');
      setResources(res.data?.data || []);
    } finally {
      setLoading(false);
    }
  };

  const buyResource = async (resourceId) => {
    try {
      setPayingId(resourceId);

      const res = await api.post(`/resources/${resourceId}/purchase/initialize`);
      const { access_code, reference } = res.data.data;

      const popup = new PaystackPop();
      popup.resumeTransaction(access_code);

      // light fallback verify after popup interaction
      const interval = setInterval(async () => {
        try {
          const verify = await api.get(`/resources/purchase/verify/${reference}`);
          if (verify.data?.data?.status === 'success') {
            clearInterval(interval);
            await fetchResources();
            window.alert('Payment successful. Resource unlocked.');
          }
        } catch {
          //
        }
      }, 4000);

      setTimeout(() => clearInterval(interval), 60000);
    } catch (err) {
      window.alert(err.response?.data?.message || 'Unable to start payment');
    } finally {
      setPayingId(null);
    }
  };

  if (loading) {
    return <div className="p-6">Loading resources...</div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-black text-text">Resource Library</h1>
        <p className="mt-2 text-muted">
          Paid and protected learning materials for nannies, customers, or both.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
        {resources.map((resource) => (
          <div key={resource.id} className="rounded-3xl border border-black/5 bg-white p-5 shadow-sm">
            {resource.cover_image_url && (
              <img
                                src={process.env.REACT_APP_IMAGE_URL_NO_TRAIL + resource.cover_image_url}
                alt={resource.title}
                className="mb-4 h-44 w-full rounded-2xl object-cover"
              />
            )}

            <div className="flex items-center justify-between gap-3">
              <h2 className="text-xl font-bold text-text">{resource.title}</h2>
              <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-bold uppercase text-primary">
                {resource.audience}
              </span>
            </div>

            <p className="mt-3 text-sm leading-6 text-muted">{resource.summary}</p>

            <div className="mt-4 flex items-center justify-between">
              <span className="text-lg font-black text-primary">
                {Number(resource.price) > 0 ? `₦${Number(resource.price).toLocaleString()}` : 'Free'}
              </span>
            </div>

            <div className="mt-5">
              {resource.has_access ? (
                <Link
                  to={`/dashboard/resources/${resource.id}`}
                  className="inline-flex w-full items-center justify-center rounded-2xl bg-primary px-4 py-3 text-sm font-bold text-white"
                >
                  Open resource
                </Link>
              ) : (
                <button
                  onClick={() => buyResource(resource.id)}
                  disabled={payingId === resource.id}
                  className="inline-flex w-full items-center justify-center rounded-2xl border border-primary/20 bg-primary/5 px-4 py-3 text-sm font-bold text-primary disabled:opacity-60"
                >
                  {payingId === resource.id ? 'Starting payment...' : 'Buy now'}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}